import {createContext} from 'react'

import {GlobalModalContextType} from '../interfaces'

const log = () => {
    // eslint-disable-next-line no-console
    console.error(`GlobalModalProvider 가 필요합니다.`)
}

export const GlobalModalContext = createContext<GlobalModalContextType>({
    isSetup: false,
    alert: {
        open: log,
        close: log,
        asyncOpen: () => {
            log()
            return Promise.resolve(false)
        },
    },
    confirm: {
        open: log,
        close: log,
        asyncOpen: () => {
            log()
            return Promise.resolve(false)
        },
    },
})
